import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import { reactive, ref, computed } from 'vue';
import { required } from '@vuelidate/validators';
import { useStore } from 'vuex';

import { useFormErrorMessageHandler } from '@/utils/form';
import { useForm } from '@/core/hooks/forms';
import { useGetOrganizationsQuery } from '@/entities/organization/hooks';
import { useCreateDeviceGroupMutation } from '@/entities/device-group/hooks';

import {
  NkForm,
  NkFormItem,
  NkInputText,
  NkButton,
  NkGroup,
  NkTextArea,
  NkSelect,
  NkOption,
} from '@/core/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceGroupAdd',
  props: {
  parent: {
    type: Number,
    default: null,
  },
},
  emits: [],
  setup(__props, { emit }) {

const props = __props


const { onSubmitted } = useForm(emit);

const store = useStore();



/**
 * If the user is an admin, he can choose any orga.
 * If the user is a responsible and have multiple orga, he can choose between those which he have access
 */
const organizationsEnabled = computed(() => (
  !props.parent
  && (
    store.getters['connection/isGranted'](['ROLE_ADMIN'])
    || (store.getters['connection/isGranted'](['ROLE_RESPONSIBLE']) && store.getters['connection/user'].organizations.length > 1)
  )
));

const fields = reactive({
  name: '',
  localization: '',
  comment: '',
  parent: props.parent,
  position: null,
  organization: null,
});

const rules = organizationsEnabled.value ? {
  name: { required },
  localization: { required },
  organization: { required },
} : {
  name: { required },
  localization: { required },
};

const form = ref();

const { data: organizations } = useGetOrganizationsQuery({ enabled: organizationsEnabled });

const {
  mutateAsync,
  isLoading,
  isError,
  error: createDeviceGroupError,
} = useCreateDeviceGroupMutation();

const { error } = useFormErrorMessageHandler(createDeviceGroupError);

const submit = () => {
  console.log('click');
  form.value.validator.$validate().then((valid: boolean) => {
    console.log('bool', valid)
    if (valid) {
      mutateAsync(
        fields,
      ).then((data) => {
        onSubmitted(data);
      });
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_unref(NkForm), {
    fields: fields,
    rules: _unref(rules),
    ref_key: "form",
    ref: form
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(NkGroup), { position: "right" }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkButton), {
            type: "primary",
            onClick: submit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('device_group.action.add')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_unref(isError))
        ? (_openBlock(), _createBlock(_component_el_alert, {
            key: 0,
            type: "error",
            title: _unref(error)
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(NkFormItem), {
        prop: "name",
        label: _ctx.$t('device_group.form.label.name')
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkInputText), {
            modelValue: fields.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fields.name) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_unref(NkFormItem), {
        prop: "localization",
        label: _ctx.$t('device_group.form.label.location')
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkInputText), {
            modelValue: fields.localization,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fields.localization) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_unref(NkFormItem), {
        label: _ctx.$t('device_group.form.label.comments')
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkTextArea), {
            modelValue: fields.comment,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fields.comment) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      (_unref(organizationsEnabled))
        ? (_openBlock(), _createBlock(_unref(NkFormItem), {
            key: 1,
            prop: "organization",
            label: _ctx.$t('device_group.form.label.organization')
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkSelect), {
                modelValue: fields.organization,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fields.organization) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(organizations), (organization) => {
                    return (_openBlock(), _createBlock(_unref(NkOption), {
                      key: organization.id,
                      label: organization.name,
                      value: organization.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["fields", "rules"])), [
    [_directive_loading, _unref(isLoading)]
  ])
}
}

})